import type { StepInfoAPI, UserOnboardingAPI, UserOnboardingStepAPI } from './APITypes';
import { Step, type StepInfo, type UserOnboarding, type UserOnboardingStep } from './Types';

const strToStep = (step?: string): Step | undefined => {
  if (step === null) {
    return undefined;
  }

  switch (step) {
    case 'ALERT_CONFIG':
      return Step.ALERT_CONFIG;
    case 'UNDERSTOOD':
      return Step.UNDERSTOOD;
    case 'INVITE_USER':
      return Step.INVITE_USER;
    case 'INSTALL_DEVICE':
      return Step.INSTALL_DEVICE;
    case 'REGISTER_DRIVER':
      return Step.REGISTER_DRIVER;
    case 'REGISTER_GEOFENCE':
      return Step.REGISTER_GEOFENCE;
    default:
      return Step.ASSOCIATE_VEHICLE;
  }
};

const stepInfoAPIToStepInfo = (stepInfoAPI: StepInfoAPI): StepInfo => {
  return {
    step: strToStep(stepInfoAPI.step)!,
    skippable: stepInfoAPI.skippable,
    dependsOn: strToStep(stepInfoAPI.depends_on),
  };
};

const userOnboardingStepAPIToUserOnboardingStep = (userOnboardingStepAPI: UserOnboardingStepAPI): UserOnboardingStep => {
  return {
    stepInfo: stepInfoAPIToStepInfo(userOnboardingStepAPI.step_info),
    userId: userOnboardingStepAPI.user_id,
    startedAt: userOnboardingStepAPI.started_at,
    endedAt: userOnboardingStepAPI.ended_at,
    skippedAt: userOnboardingStepAPI.skipped_at,
  };
};

export const userOnboardingAPIToUserOnboarding = (userOnboardingAPI?: UserOnboardingAPI): UserOnboarding | undefined => {
  if (!userOnboardingAPI) {
    return undefined;
  }

  const newOnboarding = {
    userId: userOnboardingAPI.user_id,
    dismissedAt: userOnboardingAPI.dismissed_at,
    createdAt: userOnboardingAPI.created_at,
    startedAt: userOnboardingAPI.started_at,
    endedAt: userOnboardingAPI.ended_at,
    steps: userOnboardingAPI.steps.map(userOnboardingStepAPIToUserOnboardingStep),
  };

  return newOnboarding;
};

export default userOnboardingAPIToUserOnboarding;
